<template lang="pug">
div
  .title
    div
    span(class="ht-section-title") {{title}}
    div
      router-link(:to={name:'orderList'})
        el-button.yellow-button(size="mini" type="primary") 查詢訂單
      // span(style="font-size: 12px;margin-top: 18vh;") 
//   div(v-if="isDetailGood" @click="switchArea")
//     //-  img(src="@/assets/home.png")
//   div(v-else @click="switchArea")
//     .count {{countInCart}}
//     img(src="@/assets/cart.png")

</template>

<script>
export default {
  data () {
    return {
      title: '預約洗衣服務'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>